import controller from './publishActionsCalCtrl.controller'
import template from './publishActionsCalCtrl.template.html'

export default {
  restrict: 'E',
  template,
  bindings: {
    label: '<',
    time: '<',
    timeUpdate: '<',
    enableToday: '@',
    disableClear: '@',
    boltTimes: '<',
    boltUpdate: '<',
    stateRequest: '<',
    loading: '<',
  },
  controller,
  controllerAs: 'vm',
}
